<ng-lottie
  [options]="lottieOptions"
  [width]="size + 'px'"
  [height]="size + 'px'"
>
</ng-lottie>
